import { SAVE_DOCUMENTCASE_SUCCESS,SAVE_DOCUMENTCASE_FAILED,SAVE_DOCUMENTCASE_STARTED,
    UPDATE_DOCUMENTCASE_SUCCESS,UPDATE_DOCUMENTCASE_FAILED ,UPDATE_DOCUMENTCASE_STARTED ,
    GET_ALLDOCUMENTCASE_SUCCESS,GET_ALLDOCUMENTCASE_FAILED,GET_ALLDOCUMENTCASE_STARTED,
    GET_ALLDOCUMENTCASE_BYID_SUCCESS,GET_ALLDOCUMENTCASE_BYID_FAILED,GET_ALLDOCUMENTCASE_BYID_STARTED,
    GET_ALLDOCUMENTCASE_BYUSER_SUCCESS,GET_ALLDOCUMENTCASE_BYUSER_FAILED,GET_ALLDOCUMENTCASE_BYUSER_STARTED
} from '../actions/DocumentCase';
const intialData= {
    status: {
        statusCode: 300,
        statusDisplay: "",
        statusValue: true
    },
    items: [],
    userInput: {       
        insert_datetime:"",
        inserted_by:"",
        update_datetime:"",
        updated_by:""
    
    },
    isLoading: true,
    isFormSubmit: false,
    isLoggedIn: false,
    error: ''
};
export const documentCaseData = (state = intialData, action: any) => {

  switch (action.type) {
      case SAVE_DOCUMENTCASE_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVE_DOCUMENTCASE_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVE_DOCUMENTCASE_FAILED:
    return {
      ...state,
      isLoading: true,
    };  
    case UPDATE_DOCUMENTCASE_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPDATE_DOCUMENTCASE_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPDATE_DOCUMENTCASE_FAILED:
    return {
      ...state,
      isLoading: true,
    };  
    case GET_ALLDOCUMENTCASE_BYID_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case GET_ALLDOCUMENTCASE_BYID_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case GET_ALLDOCUMENTCASE_BYID_FAILED:
    return {
      ...state,
      isLoading: true,
    };  
  default:
        return state;
    }
    
}  
export const allDocumentCaseData = (state = intialData, action: any) => {
    switch (action.type) {
    case GET_ALLDOCUMENTCASE_STARTED:  
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case GET_ALLDOCUMENTCASE_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case GET_ALLDOCUMENTCASE_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    case GET_ALLDOCUMENTCASE_BYUSER_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case GET_ALLDOCUMENTCASE_BYUSER_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case GET_ALLDOCUMENTCASE_BYUSER_FAILED:
    return {
      ...state,
      isLoading: true,
    };  
    default:
      return state;
  }
  }